// AUTO-GENERATED by scripts/merge-mission-content.mjs from _mock/_gen/*.json.
// Do not edit by hand — regenerate instead.

export const memoryByDoor = {
  "advisory": {
    "graphSpec": {
      "hub": "NC Cosmetic — Advisory",
      "entities": [
        "Veille marché",
        "Clean beauty",
        "2 sérums concurrents",
        "Digest mensuel"
      ],
      "insights": [
        "Tendance = skincare minimaliste",
        "2 concurrents déjà sur sérum clean",
        "Fenêtre Q3 se referme"
      ],
      "sources": [
        "SimilarWeb / Ahrefs",
        "Réglementation INCI/UE",
        "Revues retail beauté"
      ],
      "judgments": [
        "suggestion-sans-preuve-marche",
        "veille-sans-cadre-de-sources"
      ],
      "regulations": [
        "Toute suggestion = 2 sources",
        "Suggérer, pas décider"
      ],
      "backstory": [
        "NC sans roadmap produit",
        "Marché clean en accélération"
      ]
    },
    "backstory": "NC Cosmetic n'a pas de roadmap produit face à un marché clean beauty qui accélère. Cette mission est une veille continue (OPERATE) : observer concurrents, tendances et réglementation, puis formuler des suggestions à challenger — pas exécuter.",
    "regulations": [
      {
        "id": "r1",
        "text": "Toute suggestion de lancement s'appuie sur au moins 2 sources de veille indépendantes.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Le rôle est advisory : suggérer et challenger, jamais décider le lancement à la place du client.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Un digest publié au moins une fois par cycle, daté et sourcé.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "suggestion-sans-preuve-marche",
        "verdict": "REJECT",
        "confidence": 0.88,
        "description": "Proposer un lancement sans signal marché chiffré ni source vérifiable.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "veille-sans-cadre-de-sources",
        "verdict": "BLOCK",
        "confidence": 0.82,
        "description": "Observer le marché sans périmètre de sources défini rend la veille non reproductible.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "advisory-qui-decide",
        "verdict": "PUSH BACK",
        "confidence": 0.79,
        "description": "Transformer une suggestion en décision de lancement sort du mandat de conseil.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "Ligne sérum clean à lancer Q3",
        "detail": "2 concurrents ont déjà lancé un sérum clean ; fenêtre Q3 avant saturation.",
        "confidence": 0.74,
        "source": "Veille concurrents + tendance clean beauty",
        "status": "review"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Croiser réglementation INCI avant toute suggestion produit",
        "detail": "Une suggestion clean doit être réaliste côté formulation/UE.",
        "confidence": 0.61,
        "source": "Cycle advisory",
        "status": "proposed"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "REJECT",
        "title": "Digest sans datation ni source = non publiable",
        "detail": "Un digest non sourcé ne peut servir de base à une suggestion.",
        "confidence": 0.58,
        "source": "Revue interne veille",
        "status": "proposed"
      }
    ]
  },
  "concern": {
    "graphSpec": {
      "hub": "Horion Consulting — Concern",
      "entities": [
        "Notes de frais",
        "Plan comptable",
        "Justificatifs (Heroku/Telenet/OVH)",
        "Rapprochement CSV"
      ],
      "insights": [
        "2-3h/mois, ~80 lignes",
        "Douleur = retrouver le justificatif",
        "Cadrage avant build"
      ],
      "sources": [
        "Entretien finance",
        "Export CSV bancaire",
        "Boîte mail providers"
      ],
      "judgments": [
        "builder-avant-cadrer",
        "decision-sans-volumetrie"
      ],
      "regulations": [
        "Mesurer la douleur d'abord",
        "Décision Goal-ou-Maintain explicite"
      ],
      "backstory": [
        "Consolidation 100% manuelle",
        "Récurrence mensuelle"
      ]
    },
    "backstory": "Horion Consulting consolide ses notes de frais à la main : rapprochement CSV bancaire contre justificatifs (emails providers Heroku/Telenet/OVH), 2-3h par mois pour ~80 lignes. La mission n'est pas de coder l'outil mais de CADRER l'approche : diagnostiquer la vraie douleur, poser les options, fixer le périmètre, puis trancher entre engendrer un Goal (builder l'agent) ou une Maintain (le run mensuel).",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucune option chiffrée sans volumétrie réelle (lignes/mois, temps mesuré, taux de justificatifs manquants).",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Le cadrage se clôt par une décision explicite Goal-ou-Maintain, jamais par un 'on verra'.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Le plan comptable du client fait foi : aucune catégorie inventée hors de son référentiel.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "builder-avant-cadrer",
        "verdict": "BLOCK",
        "confidence": 0.91,
        "description": "Spécifier ou coder l'agent avant d'avoir diagnostiqué la douleur et arrêté le périmètre.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "decision-sans-volumetrie",
        "verdict": "REJECT",
        "confidence": 0.84,
        "description": "Trancher Goal-vs-Maintain sans les chiffres (volume mensuel, temps réel, % justificatifs introuvables).",
        "status": "proposed"
      },
      {
        "id": "j3",
        "pattern": "categorie-hors-referentiel",
        "verdict": "REVERT",
        "confidence": 0.72,
        "description": "Proposer une catégorisation qui n'existe pas dans le plan comptable du client.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "La douleur est la recherche du justificatif, pas la catégorisation",
        "detail": "Catégoriser ~80 lignes est rapide ; retrouver l'email/facture provider mange l'essentiel des 2-3h.",
        "confidence": 0.78,
        "source": "Entretien finance",
        "status": "review"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Exiger la volumétrie avant toute option chiffrée",
        "detail": "",
        "confidence": 0.64,
        "source": "Cadrage concern",
        "status": "proposed"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "PUSH BACK",
        "title": "Périmètre élargi à la TVA dès le cadrage",
        "detail": "Tentation d'inclure récupération TVA et contrôle de conformité ; à reporter, hors douleur initiale.",
        "confidence": 0.55,
        "source": "Atelier options",
        "status": "proposed"
      }
    ]
  },
  "decision": {
    "graphSpec": {
      "hub": "HLC — Decision",
      "entities": [
        "App unifiée modulaire",
        "Deux apps séparées",
        "~60% features communes",
        "Modules activables"
      ],
      "insights": [
        "Reco = unifiée modulaire",
        "Coût maintenance divisé",
        "Risque divergence à 18 mois"
      ],
      "sources": [
        "Audit features asset/property",
        "Coûts de maintenance estimés"
      ],
      "judgments": [
        "decider-sans-chiffrer-les-options",
        "ignorer-le-risque-de-divergence"
      ],
      "regulations": [
        "Critères figés avant l'évaluation",
        "UX préservée par module"
      ],
      "backstory": [
        "Deux segments, une plateforme",
        "Trancher avant le build"
      ]
    },
    "backstory": "HLC sert deux segments — asset-managers et property-managers — partageant ~60% de features. La mission tranche AVANT le build : une app unifiée modulaire ou deux apps séparées, en pesant coût de maintenance contre risque de divergence des besoins à 18 mois.",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucune option n'est pesée sans critères de décision figés et pondérés au préalable.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Chaque option est chiffrée (coût build + coût maintenance 18 mois) avant la recommandation.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "L'UX de chaque segment doit rester préservée — un module activable ne dégrade pas l'autre segment.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "decider-sans-chiffrer-les-options",
        "verdict": "BLOCK",
        "confidence": 0.91,
        "description": "Recommander une architecture sans coût build ni coût de maintenance chiffrés rend l'arbitrage non défendable.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "ignorer-le-risque-de-divergence",
        "verdict": "PUSH BACK",
        "confidence": 0.78,
        "description": "Trancher pour l'unifiée sans modéliser la divergence des besoins à 18 mois masque le vrai coût du choix.",
        "status": "proposed"
      },
      {
        "id": "j3",
        "pattern": "critere-ajoute-apres-coup",
        "verdict": "REJECT",
        "confidence": 0.84,
        "description": "Ajouter ou repondérer un critère après avoir vu les chiffres biaise la décision vers une conclusion pré-choisie.",
        "status": "confirmed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "Unifiée modulaire = maintenance la moins chère",
        "detail": "~60% de features communes maintenues une seule fois ; modules activables isolent les 40% spécifiques par segment.",
        "confidence": 0.79,
        "source": "Audit features asset/property",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "judgment",
        "verdict": "PUSH BACK",
        "title": "Modéliser la divergence à 18 mois",
        "detail": "Si les roadmaps des deux segments divergent fortement, le coût de découplage tardif peut dépasser l'économie initiale.",
        "confidence": 0.62,
        "source": "Reco unifiée modulaire",
        "status": "review"
      },
      {
        "id": "p3",
        "kind": "regulation",
        "title": "Figer les critères avant de chiffrer",
        "detail": "",
        "confidence": 0.71,
        "source": "Cadrage décision",
        "status": "proposed"
      }
    ]
  },
  "goal": {
    "graphSpec": {
      "hub": "Atlas AM — Goal",
      "entities": [
        "MVP reporting",
        "API custodian",
        "Stub interne",
        "3 pilotes"
      ],
      "insights": [
        "Custodian = chemin critique",
        "Socle données d'abord",
        "MVP en S8"
      ],
      "sources": [
        "Specs custodian",
        "Interviews pilotes"
      ],
      "judgments": [
        "jalon-glissant-non-signale",
        "pilote-sans-onboarding"
      ],
      "regulations": [
        "Jalons S2/S5/S8 fixes",
        "Stub iso-contrat custodian"
      ],
      "backstory": [
        "Reporting manuel Excel",
        "Custodian en retard"
      ]
    },
    "backstory": "Atlas AM produit ses reportings clients à la main sous Excel, ingérable au-delà de quelques mandats. La mission livre le MVP de l'app de reporting en S8 pour 3 clients pilotes, avec une dépendance API custodian attendue en S3 et mitigée par un stub interne.",
    "regulations": [
      {
        "id": "r1",
        "text": "Les jalons S2/S5/S8 sont fixes : tout glissement est signalé au sponsor sous 24h.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Le stub custodian respecte le contrat d'interface réel (mêmes champs, mêmes erreurs) pour un swap sans refactor.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Aucun pilote onboardé sans un 1er rapport généré et relu de bout en bout.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "jalon-glissant-non-signale",
        "verdict": "BLOCK",
        "confidence": 0.91,
        "description": "Laisser filer un jalon S2/S5/S8 sans alerter le sponsor casse l'engagement S8.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "stub-divergent-du-contrat",
        "verdict": "REJECT",
        "confidence": 0.84,
        "description": "Un stub qui s'écarte du contrat custodian crée une dette invisible au moment du swap S3.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "pilote-sans-onboarding",
        "verdict": "PUSH BACK",
        "confidence": 0.72,
        "description": "Activer un pilote sans onboarding ni 1er rapport relu garantit un churn précoce.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "Le custodian est le chemin critique",
        "detail": "API attendue S3 ; le stub interne débloque socle + 1er rapport en parallèle.",
        "confidence": 0.8,
        "source": "Specs custodian",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Geler le schéma du socle données avant le 1er rapport",
        "detail": "Un schéma instable propage des reprises sur tous les rapports.",
        "confidence": 0.61,
        "source": "Retours architecture",
        "status": "review"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "PUSH BACK",
        "title": "Scope MVP figé à 3 pilotes",
        "detail": "Ajouter un 4e pilote avant S8 menace le release.",
        "confidence": 0.55,
        "source": "Discovery",
        "status": "proposed"
      }
    ]
  },
  "idea": {
    "graphSpec": {
      "hub": "The Moment — Idea",
      "entities": [
        "Landing « Réserver »",
        "Seuil 50 signups / 2 sem",
        "Tracking clics",
        "Verdict kill/refine/proceed"
      ],
      "insights": [
        "Friction = DM Instagram",
        "Tester avant de build",
        "Signal = intention, pas trafic"
      ],
      "sources": [
        "DM Instagram actuels",
        "Analytics landing"
      ],
      "judgments": [
        "build-avant-validation",
        "vanity-metric-comme-signal"
      ],
      "regulations": [
        "Seuil fixé avant le test",
        "Pas de build avant verdict"
      ],
      "backstory": [
        "Réservation par DM",
        "Demande non prouvée"
      ]
    },
    "backstory": "The Moment (bar à ongles, Overijse) prend ses réservations via DM Instagram, source de friction et de no-shows. Avant d'engager le moindre build d'app, la mission teste s'il existe une vraie demande : une landing avec bouton « Réserver », seuil de 50 signups en 2 semaines, et un verdict kill/refine/proceed qui n'engendre un Goal que si proceed.",
    "regulations": [
      {
        "id": "r1",
        "text": "Le seuil de succès (50 signups / 2 semaines) est fixé AVANT le lancement du test, jamais ajusté en cours de route.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Aucune ligne de code d'app n'est engagée avant le verdict proceed.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Le signal compté est l'intention (signup / clic « Réserver »), pas le trafic ni les vues.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "build-avant-validation",
        "verdict": "BLOCK",
        "confidence": 0.92,
        "description": "Engager le build de l'app avant d'avoir prouvé la demande inverse l'ordre du test.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "vanity-metric-comme-signal",
        "verdict": "REJECT",
        "confidence": 0.84,
        "description": "Compter les vues ou le trafic comme preuve de demande au lieu des signups d'intention.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "seuil-deplace-apres-coup",
        "verdict": "PUSH BACK",
        "confidence": 0.78,
        "description": "Abaisser le seuil après un résultat décevant pour forcer un proceed.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "La friction réelle est le DM, pas le prix",
        "detail": "Les clientes abandonnent au moment de négocier le créneau en DM ; un bouton direct devrait lever ça.",
        "confidence": 0.71,
        "source": "DM Instagram actuels",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Fenêtre fixe de 2 semaines, pas de prolongation",
        "detail": "Prolonger le test fausse le seuil temporel et masque un refine.",
        "confidence": 0.63,
        "source": "Cadre du test",
        "status": "proposed"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "REVERT",
        "title": "Pas de funnel multi-étapes dans le test",
        "detail": "Ajouter paiement/compte avant le verdict gonfle le scope et brouille le signal d'intention.",
        "confidence": 0.58,
        "source": "Scope du test",
        "status": "review"
      }
    ]
  },
  "improve": {
    "graphSpec": {
      "hub": "NC Cosmetic — Improve",
      "entities": [
        "Tunnel checkout",
        "A/B variante 4 champs",
        "Baseline 3,4 %",
        "Backlog leviers"
      ],
      "insights": [
        "Levier #1 = checkout",
        "7→4 champs",
        "Cible +0,8 pp/trimestre"
      ],
      "sources": [
        "Analytics GA4",
        "Session replays",
        "Benchmarks CRO"
      ],
      "judgments": [
        "multi-levier-simultane",
        "gagnant-sans-significativite"
      ],
      "regulations": [
        "Significativité requise",
        "Re-mesurer la baseline"
      ],
      "backstory": [
        "Conversion plate",
        "Friction paiement"
      ]
    },
    "backstory": "NC Cosmetic plafonne à 3,4 % de conversion depuis deux trimestres. La mission est un cycle de steering continu : on attaque un levier à la fois, on déploie, on mesure à significativité, puis on cadre le levier suivant.",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucune variante déclarée gagnante sans significativité statistique (95 %).",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Re-mesurer la baseline après chaque levier statué avant d'ouvrir le suivant.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Un seul levier en test simultané sur le tunnel.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "multi-levier-simultane",
        "verdict": "BLOCK",
        "confidence": 0.91,
        "description": "Tester checkout + un autre levier en parallèle rend l'attribution du gain impossible.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "gagnant-sans-significativite",
        "verdict": "REJECT",
        "confidence": 0.87,
        "description": "Statuer une variante avant d'atteindre la taille d'échantillon et le seuil de p-value.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "peeking-precoce-ab",
        "verdict": "PUSH BACK",
        "confidence": 0.74,
        "description": "Regarder les résultats avant la fin du run gonfle le taux de faux positifs.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "Le checkout est le levier #1",
        "detail": "Tunnel 7 champs : 38 % d'abandon au paiement. Passage à 4 champs attendu à +0,6 pp.",
        "confidence": 0.83,
        "source": "Analytics GA4 + session replays",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Geler la baseline 14 jours avant d'ouvrir le levier suivant",
        "detail": "Évite le bruit saisonnier entre deux itérations du cycle.",
        "confidence": 0.61,
        "source": "Cycle improve",
        "status": "review"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "PUSH BACK",
        "title": "Levier suivant candidat : autofill adresse",
        "detail": "Friction résiduelle sur la saisie adresse après réduction des champs.",
        "confidence": 0.55,
        "source": "Backlog leviers",
        "status": "proposed"
      }
    ]
  },
  "maintain": {
    "graphSpec": {
      "hub": "Life Connect — Maintain",
      "entities": [
        "File d'entrant",
        "SLA P1 4h",
        "Purge des logs",
        "Renouvellement certs"
      ],
      "insights": [
        "7 tickets ouverts",
        "Récurrent = automatisable",
        "Incident majeur → Issue"
      ],
      "sources": [
        "Backlog tickets",
        "Logs production",
        "Dashboard SLA"
      ],
      "judgments": [
        "fix-sans-runbook",
        "automatiser-sans-rollback"
      ],
      "regulations": [
        "SLA P1 sous 4h",
        "Idempotency obligatoire"
      ],
      "backstory": [
        "Plateforme en run",
        "Récurrent manuel"
      ]
    },
    "backstory": "Life Connect est en production et doit rester en marche : l'entrant arrive en continu sous SLA (P1 4h) et le récurrent (purge des logs, renouvellement des certs) est encore traité à la main. La mission n'est pas un build : c'est un steering OPERATE qui triage l'entrant, patche, et automatise ce qui se répète.",
    "regulations": [
      {
        "id": "r1",
        "text": "Tout ticket P1 doit être adressé (mitigation ou fix) sous 4h.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Toute automatisation du récurrent doit être idempotente et avoir un rollback documenté.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Un incident majeur ouvre une Issue dédiée avant tout fix.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "fix-sans-runbook",
        "verdict": "REJECT",
        "confidence": 0.84,
        "description": "Patcher un incident en prod sans tracer la cause ni mettre à jour le runbook.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "automatiser-sans-rollback",
        "verdict": "BLOCK",
        "confidence": 0.9,
        "description": "Déployer une automatisation (purge, renouvellement) sans rollback ni dry-run.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "triage-sans-priorisation-sla",
        "verdict": "PUSH BACK",
        "confidence": 0.72,
        "description": "Traiter l'entrant dans l'ordre d'arrivée au lieu de prioriser par SLA.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "La purge des logs est le récurrent #1 à automatiser",
        "detail": "Tâche manuelle hebdomadaire, faible risque, fort gain de temps ops.",
        "confidence": 0.78,
        "source": "Backlog tickets",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Dry-run obligatoire avant toute purge automatisée",
        "detail": "Valider le périmètre supprimé avant exécution réelle.",
        "confidence": 0.64,
        "source": "Cycle maintain",
        "status": "proposed"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "REJECT",
        "title": "Renouvellement cert sans alerte d'expiration",
        "detail": "Automatiser le renouvellement sans monitoring d'expiration laisse un angle mort.",
        "confidence": 0.6,
        "source": "Incident cert J-2",
        "status": "review"
      }
    ]
  },
  "monitor": {
    "graphSpec": {
      "hub": "Jardinac — Monitor",
      "entities": [
        "Rétention client",
        "Seuil 70 %",
        "Dashboard rétention",
        "Slack #ops"
      ],
      "insights": [
        "Lecture 74 % stable",
        "Surveiller, ne pas agir",
        "Franchissement → Goal"
      ],
      "sources": [
        "Pipeline KPI",
        "Logs facturation"
      ],
      "judgments": [
        "alerte-sans-seuil-defini",
        "monitor-qui-agit"
      ],
      "regulations": [
        "Un seul seuil par alerte",
        "Pas d'action sans Goal"
      ],
      "backstory": [
        "Rétention proche du plancher",
        "Aucune visibilité quotidienne"
      ]
    },
    "backstory": "Jardinac navigue à 74 % de rétention sans alerte quand ça décroche. La mission n'est pas de réparer mais d'instrumenter une vigie : surveiller en continu et alerter dès que la rétention franchit 70 %, sans jamais agir à la place du client.",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucune alerte sans seuil chiffré et source de vérité unique.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Le monitor observe et alerte, il ne déclenche aucune action corrective lui-même.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Tout franchissement de seuil ouvre un Goal/Issue tracé, jamais une notif orpheline.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "alerte-sans-seuil-defini",
        "verdict": "BLOCK",
        "confidence": 0.91,
        "description": "Une alerte sans seuil chiffré ni source figée est ingérable et bruyante.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "monitor-qui-agit",
        "verdict": "REVERT",
        "confidence": 0.88,
        "description": "Le monitor qui corrige de lui-même sort de son périmètre : il observe, il alerte.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "seuil-sans-hysteresis",
        "verdict": "PUSH BACK",
        "confidence": 0.72,
        "description": "Un seuil sec sans hysteresis fait clignoter l'alerte à chaque oscillation autour de 70 %.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "74 % stable mais sans marge",
        "detail": "4 points seulement au-dessus du seuil : un churn saisonnier suffit à franchir.",
        "confidence": 0.78,
        "source": "Pipeline KPI",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Ajouter une hysteresis de 2 points sur l'alerte",
        "detail": "Déclencher sous 70 %, ne ré-armer qu'au-dessus de 72 % pour éviter le flapping.",
        "confidence": 0.64,
        "source": "Boucle de surveillance",
        "status": "review"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "REJECT",
        "title": "Refuser les notifs Slack non idempotentes",
        "detail": "Un re-run du check ne doit pas re-spammer #ops pour le même franchissement.",
        "confidence": 0.7,
        "source": "Tuning triggers",
        "status": "proposed"
      }
    ]
  },
  "prototype": {
    "graphSpec": {
      "hub": "NC Cosmetic — Prototype",
      "entities": [
        "Spike jetable",
        "1 écran mocké",
        "Hypothèse 'scan miroir'",
        "Décision go/no-go"
      ],
      "insights": [
        "Apprendre, pas livrer",
        "0 backend, data en dur",
        "3 jours d'appetite"
      ],
      "sources": [
        "Interviews users",
        "Hypothèse PO"
      ],
      "judgments": [
        "prototype-qui-devient-prod",
        "spike-sans-question-cadree"
      ],
      "regulations": [
        "Throwaway dès le départ",
        "Décision keep/throw obligatoire"
      ],
      "backstory": [
        "Hypothèse non testée",
        "Risque d'over-build"
      ]
    },
    "backstory": "NC Cosmetic veut tester si un écran 'scan miroir + reco produit' déclenche l'intérêt, sans engager de roadmap. La mission est un spike jetable de 3 jours : le code est consommable, le seul livrable est une décision go/no-go qui engendrera soit un Goal (app), soit une Automation (workflow).",
    "regulations": [
      {
        "id": "r1",
        "text": "Le prototype est jetable : aucun code de spike ne part en prod sans réécriture.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Le spike se termine par une décision explicite keep / throw / promote.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "0 backend : toutes les données sont mockées en dur dans l'écran.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "prototype-qui-devient-prod",
        "verdict": "BLOCK",
        "confidence": 0.92,
        "description": "Promouvoir le code du spike tel quel en production trahit le contrat 'jetable'.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "spike-sans-question-cadree",
        "verdict": "PUSH BACK",
        "confidence": 0.84,
        "description": "Lancer le vibe-coding avant d'avoir écrit l'hypothèse falsifiable à tester.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "scope-au-dela-d-un-ecran",
        "verdict": "REVERT",
        "confidence": 0.78,
        "description": "Ajouter un 2e écran ou un vrai backend explose l'appetite de 3 jours.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "Une démo live vaut mieux qu'un deck",
        "detail": "La décision go/no-go se prend devant l'écran cliquable, pas sur slides.",
        "confidence": 0.74,
        "source": "Interviews users",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Timeboxer le spike à 3 jours fermes",
        "detail": "Au-delà, on tranche avec ce qu'on a plutôt que d'étendre.",
        "confidence": 0.68,
        "source": "Appetite mission",
        "status": "proposed"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "REJECT",
        "title": "Données réalistes mais réelles = sur-ingénierie",
        "detail": "Brancher une vraie source de données pendant le spike est un piège classique.",
        "confidence": 0.61,
        "source": "Rétro spikes précédents",
        "status": "review"
      }
    ]
  },
  "question": {
    "graphSpec": {
      "hub": "Jardinac — Question",
      "entities": [
        "TCO 3 ans",
        "Modules Odoo sur-mesure",
        "Reprise de données",
        "ERPNext"
      ],
      "insights": [
        "Reprise ≈ 40% du coût",
        "Lock-in = modules custom",
        "Statu quo a un coût caché"
      ],
      "sources": [
        "Inventaire modules Odoo",
        "Devis intégrateurs",
        "Benchmarks ERPNext"
      ],
      "judgments": [
        "tco-sans-reprise-de-donnees",
        "chiffrage-sans-source"
      ],
      "regulations": [
        "Chaque poste sourcé",
        "Horizon 3 ans fixe"
      ],
      "backstory": [
        "Dépendance Odoo",
        "Coût réel inconnu"
      ]
    },
    "backstory": "Jardinac veut sortir d'Odoo mais ignore le coût réel de la migration. La mission n'est pas de migrer : c'est de chiffrer honnêtement le TCO 3 ans des alternatives pour décider en connaissance de cause, sachant que la reprise de données est le poste dominant et que le lock-in vient des modules sur-mesure.",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucun poste de coût retenu sans source chiffrée (devis, grille de prix, ou estimation traçable).",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Le TCO est calculé sur un horizon fixe de 3 ans, licences + dev + reprise + formation inclus.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Le statu quo (rester sur Odoo) est chiffré comme une alternative à part entière, pas comme un coût nul.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "tco-sans-reprise-de-donnees",
        "verdict": "BLOCK",
        "confidence": 0.92,
        "description": "Un TCO qui omet ou sous-estime la reprise de données (≈40% du coût) est faux par construction.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "chiffrage-sans-source",
        "verdict": "REJECT",
        "confidence": 0.88,
        "description": "Avancer un montant sans devis ni grille de prix traçable.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "lock-in-ignore-dans-le-comparatif",
        "verdict": "PUSH BACK",
        "confidence": 0.74,
        "description": "Comparer les alternatives sans valoriser le coût de re-développement des modules sur-mesure.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "La reprise de données est le poste dominant",
        "detail": "≈40% du TCO 3 ans ; à chiffrer en premier car elle conditionne la viabilité de chaque scénario.",
        "confidence": 0.85,
        "source": "Inventaire modules + devis intégrateurs",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "judgment",
        "verdict": "PUSH BACK",
        "title": "Le lock-in doit entrer dans le comparatif",
        "detail": "Les modules Odoo sur-mesure imposent un coût de re-développement qui fausse la comparaison s'il est ignoré.",
        "confidence": 0.7,
        "source": "Inventaire modules Odoo",
        "status": "review"
      },
      {
        "id": "p3",
        "kind": "regulation",
        "title": "Chiffrer le statu quo comme une option",
        "detail": "Rester sur Odoo a un coût (licences + maintenance des modules custom) — jamais zéro.",
        "confidence": 0.62,
        "source": "Modèle TCO",
        "status": "proposed"
      }
    ]
  },
  "review": {
    "graphSpec": {
      "hub": "Life Connect — Review",
      "entities": [
        "Logs admin",
        "Clés API",
        "Surface d'attaque",
        "Archi sans SPOF"
      ],
      "insights": [
        "2 bloquants, 4 importants",
        "Go conditionnel",
        "Trier par sévérité"
      ],
      "sources": [
        "Diagramme archi",
        "Scan sécurité"
      ],
      "judgments": [
        "verdict-sans-preuve",
        "secret-en-clair-au-repos"
      ],
      "regulations": [
        "1 Issue par bloquant",
        "Pas de go sans preuve"
      ],
      "backstory": [
        "Déploiement imminent",
        "Données de santé"
      ]
    },
    "backstory": "Life Connect, plateforme de mise en relation patients-soignants, vise un déploiement production. La direction exige un audit sécurité + architecture pour statuer go/no-go avant d'exposer des données de santé.",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucun go déclaré sans preuve attachée par finding (capture, scan, payload).",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Tout bloquant engendre exactement une Issue traçable avant le verdict.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Findings triés par sévérité avant arbitrage go/no-go.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "secret-en-clair-au-repos",
        "verdict": "BLOCK",
        "confidence": 0.94,
        "description": "Logs admin non chiffrés au repos : exfiltration directe de données sensibles.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "cles-api-sans-rotation",
        "verdict": "BLOCK",
        "confidence": 0.9,
        "description": "Pas de rotation des clés API : une fuite reste exploitable indéfiniment.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "verdict-sans-preuve",
        "verdict": "REJECT",
        "confidence": 0.85,
        "description": "Statuer go/no-go sans preuve reproductible par finding.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "judgment",
        "verdict": "BLOCK",
        "title": "Chiffrer les logs admin au repos",
        "detail": "Bloquant #1 : activer le chiffrement at-rest sur le store de logs admin avant tout go.",
        "confidence": 0.88,
        "source": "Scan sécurité",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Rotation automatique des clés API (90 j)",
        "detail": "Bloquant #2 : imposer un cycle de rotation et révocation des clés API.",
        "confidence": 0.8,
        "source": "Audit sécurité",
        "status": "review"
      },
      {
        "id": "p3",
        "kind": "insight",
        "title": "Archi sans SPOF critique",
        "detail": "Aucun point unique de défaillance bloquant : le no-go ne tient qu'aux 2 fixes sécurité.",
        "confidence": 0.74,
        "source": "Diagramme archi",
        "status": "accepted"
      }
    ]
  }
};

export const squadByDoor = {
  "advisory": {
    "lead": {
      "name": "Sasha",
      "champion_slug": "sasha-scout",
      "role": "Market Scout Lead",
      "mentalModel": "Observer dehors, suggérer dedans"
    },
    "permanent": [
      {
        "name": "Cléo",
        "champion_slug": "cleo-competitive",
        "role": "Competitive Analyst",
        "mentalModel": "Chaque concurrent = un signal daté"
      },
      {
        "name": "Tariq",
        "champion_slug": "tariq-trends",
        "role": "Trend Researcher",
        "mentalModel": "Distinguer tendance de mode passagère"
      }
    ],
    "temporary": [
      {
        "name": "Reza",
        "champion_slug": "reza-regulatory",
        "role": "Regulatory Reviewer",
        "mentalModel": "Faisable côté INCI/UE ou rien",
        "note": "Ponctuel — revue réglementaire des suggestions clean (2 stories)"
      }
    ],
    "stakeholders": [
      {
        "name": "Nadia (NC Cosmetic)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "concern": {
    "lead": {
      "name": "Cédric",
      "champion_slug": "cadrik-framer",
      "role": "Cadreur (Discovery Lead)",
      "mentalModel": "Diagnostiquer avant de bâtir"
    },
    "permanent": [
      {
        "name": "Naïma",
        "champion_slug": "naima-ops",
        "role": "Ops Analyst",
        "mentalModel": "Mesurer la douleur, chiffrer le volume"
      },
      {
        "name": "Bruno",
        "champion_slug": "bruno-compta",
        "role": "Expert Plan Comptable",
        "mentalModel": "Le référentiel client fait foi"
      },
      {
        "name": "Léa",
        "champion_slug": "lea-architect",
        "role": "Solution Architect",
        "mentalModel": "Options réalistes, pas de sur-ingénierie"
      }
    ],
    "temporary": [
      {
        "name": "Hugo",
        "champion_slug": "hugo-security",
        "role": "Security Reviewer",
        "mentalModel": "Accès emails providers = surface sensible",
        "note": "Ponctuel — revue accès données (emails/CSV) sur 2 stories"
      }
    ],
    "stakeholders": [
      {
        "name": "Sophie (Horion Consulting)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "decision": {
    "lead": {
      "name": "Diane",
      "champion_slug": "diana-decider",
      "role": "Decision Architect",
      "mentalModel": "Critères d'abord, chiffres ensuite, reco en dernier"
    },
    "permanent": [
      {
        "name": "Paul",
        "champion_slug": "paul-product",
        "role": "Product Strategist",
        "mentalModel": "Préserver l'UX de chaque segment"
      },
      {
        "name": "Théo",
        "champion_slug": "theo-techlead",
        "role": "Tech Lead",
        "mentalModel": "Chiffrer build + maintenance, sans optimisme"
      },
      {
        "name": "Marc",
        "champion_slug": "marc-data",
        "role": "Data Analyst",
        "mentalModel": "Quantifier le recouvrement et la divergence"
      }
    ],
    "temporary": [
      {
        "name": "Sofia",
        "champion_slug": "sofia-finance",
        "role": "FinOps Reviewer",
        "mentalModel": "Coût total sur 18 mois, pas le sticker price",
        "note": "Ponctuel — revue du chiffrage TCO des deux options (1 story)"
      }
    ],
    "stakeholders": [
      {
        "name": "Nadia (HLC)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "goal": {
    "lead": {
      "name": "Grégoire",
      "champion_slug": "greg-goalkeeper",
      "role": "Delivery Lead",
      "mentalModel": "Le S8 est sacré, le scope est négociable"
    },
    "permanent": [
      {
        "name": "Bruno",
        "champion_slug": "bruno-backend",
        "role": "Backend Engineer",
        "mentalModel": "Socle données stable d'abord"
      },
      {
        "name": "Sofia",
        "champion_slug": "sofia-fullstack",
        "role": "Fullstack Engineer",
        "mentalModel": "Le 1er rapport doit être démo-able"
      },
      {
        "name": "Inès",
        "champion_slug": "ines-onboarding",
        "role": "Customer Success",
        "mentalModel": "Un pilote onboardé est un pilote relu"
      }
    ],
    "temporary": [
      {
        "name": "Karim",
        "champion_slug": "karim-security",
        "role": "Security Reviewer",
        "mentalModel": "Adversarial sur les données clients",
        "note": "Ponctuel — audit sécurité du socle données et du stub (2 stories)"
      }
    ],
    "stakeholders": [
      {
        "name": "Camille (Atlas AM)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "idea": {
    "lead": {
      "name": "Valentine",
      "champion_slug": "vera-validator",
      "role": "Discovery Lead",
      "mentalModel": "Prouver la demande avant d'écrire une ligne de code"
    },
    "permanent": [
      {
        "name": "Sacha",
        "champion_slug": "sacha-research",
        "role": "UX Researcher",
        "mentalModel": "Interviewer les clientes — comprendre le « pourquoi DM »"
      },
      {
        "name": "Sam",
        "champion_slug": "sam-business",
        "role": "Business Analyst",
        "mentalModel": "Cadrer le Job-To-Be-Done, dimensionner la demande réelle"
      },
      {
        "name": "Marc",
        "champion_slug": "marc-data",
        "role": "Data Analyst",
        "mentalModel": "Lire les signaux existants (DM, no-shows) — pas fabriquer du trafic"
      }
    ],
    "temporary": [
      {
        "name": "Simon",
        "champion_slug": "simon-strategist",
        "role": "Strategist",
        "mentalModel": "Cadrer les options : app dédiée vs no-code vs statu quo",
        "note": "Ponctuel — arbitrage build-vs-buy pour le Verdict (1 story)"
      }
    ],
    "stakeholders": [
      {
        "name": "Sofia (The Moment)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "improve": {
    "lead": {
      "name": "Olivia",
      "champion_slug": "olga-optimizer",
      "role": "CRO Optimizer",
      "mentalModel": "Un levier, une mesure, on statue"
    },
    "permanent": [
      {
        "name": "Marc",
        "champion_slug": "marc-data",
        "role": "Data Analyst",
        "mentalModel": "Significativité avant tout"
      },
      {
        "name": "Igor",
        "champion_slug": "igor-frontend",
        "role": "Frontend Engineer",
        "mentalModel": "Implémenter les variantes proprement"
      }
    ],
    "temporary": [
      {
        "name": "Rapha",
        "champion_slug": "rapha-reviewer",
        "role": "CRO Reviewer",
        "mentalModel": "Adversarial sur les gains annoncés",
        "note": "Ponctuel — revue de significativité (1 story par cycle)"
      }
    ],
    "stakeholders": [
      {
        "name": "Nadia (NC Cosmetic)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "maintain": {
    "lead": {
      "name": "Sacha",
      "champion_slug": "sven-supervisor",
      "role": "Ops Lead",
      "mentalModel": "SLA d'abord, automatiser le répétable"
    },
    "permanent": [
      {
        "name": "Théo",
        "champion_slug": "theo-oncall",
        "role": "On-call Engineer",
        "mentalModel": "Mitiger vite, tracer la cause"
      },
      {
        "name": "Nora",
        "champion_slug": "nora-automation",
        "role": "Automation Engineer",
        "mentalModel": "Idempotent ou rien"
      },
      {
        "name": "Iris",
        "champion_slug": "iris-triage",
        "role": "Support Triage",
        "mentalModel": "Prioriser par SLA, pas par arrivée"
      }
    ],
    "temporary": [
      {
        "name": "Boris",
        "champion_slug": "boris-secaudit",
        "role": "Security Reviewer",
        "mentalModel": "Adversarial sur les secrets et les certs",
        "note": "Ponctuel — audit sécurité du renouvellement des certs (2 stories)"
      }
    ],
    "stakeholders": [
      {
        "name": "Camille (Life Connect)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "monitor": {
    "lead": {
      "name": "Sven",
      "champion_slug": "sven-supervisor",
      "role": "Monitoring Lead",
      "mentalModel": "Observer, alerter, ne pas agir"
    },
    "permanent": [
      {
        "name": "Dina",
        "champion_slug": "dina-data",
        "role": "Data Engineer",
        "mentalModel": "Une source de vérité, un KPI fiable"
      },
      {
        "name": "Oscar",
        "champion_slug": "oscar-ops",
        "role": "Ops Engineer",
        "mentalModel": "Alertes idempotentes, pas de bruit"
      }
    ],
    "temporary": [
      {
        "name": "Rita",
        "champion_slug": "rita-reliability",
        "role": "Reliability Reviewer",
        "mentalModel": "Adversarial sur les faux positifs",
        "note": "Ponctuel — revue triggers + hysteresis (2 stories)"
      }
    ],
    "stakeholders": [
      {
        "name": "Camille (Jardinac)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "prototype": {
    "lead": {
      "name": "Vince",
      "champion_slug": "vince-vibe",
      "role": "Prototype Lead",
      "mentalModel": "Apprendre vite, jeter sans regret"
    },
    "permanent": [
      {
        "name": "Igor",
        "champion_slug": "igor-frontend",
        "role": "Frontend Engineer",
        "mentalModel": "Un écran, données en dur"
      },
      {
        "name": "Pia",
        "champion_slug": "pia-product",
        "role": "Product Designer",
        "mentalModel": "Cadrer l'hypothèse falsifiable"
      }
    ],
    "temporary": [
      {
        "name": "Léa",
        "champion_slug": "lea-researcher",
        "role": "UX Researcher",
        "mentalModel": "Lire le signal de la démo",
        "note": "Ponctuelle — facilitation démo + synthèse learn (1 story)"
      }
    ],
    "stakeholders": [
      {
        "name": "Nadia (NC Cosmetic)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "question": {
    "lead": {
      "name": "Régis",
      "champion_slug": "regis-researcher",
      "role": "Research Lead",
      "mentalModel": "Pas de chiffre sans source"
    },
    "permanent": [
      {
        "name": "Camille",
        "champion_slug": "camille-finops",
        "role": "FinOps Analyst",
        "mentalModel": "Tout converge dans le modèle TCO"
      },
      {
        "name": "Théo",
        "champion_slug": "theo-erp",
        "role": "ERP Analyst",
        "mentalModel": "Inventorier avant de chiffrer"
      }
    ],
    "temporary": [
      {
        "name": "Sven",
        "champion_slug": "sven-data-migration",
        "role": "Data Migration Specialist",
        "mentalModel": "La reprise coûte plus qu'on ne croit",
        "note": "Ponctuel — chiffrage de la reprise de données (1 story, poste dominant)"
      }
    ],
    "stakeholders": [
      {
        "name": "Hélène (Jardinac)",
        "role": "Sponsor",
        "human_role": "board-member"
      },
      {
        "name": "Marc (Jardinac IT)",
        "role": "Tech Lead",
        "human_role": "stakeholder"
      }
    ]
  },
  "review": {
    "lead": {
      "name": "Sven",
      "champion_slug": "sven-supervisor",
      "role": "Audit Lead",
      "mentalModel": "Pas de verdict sans preuve"
    },
    "permanent": [
      {
        "name": "Aïcha",
        "champion_slug": "aicha-architect",
        "role": "Architecture Reviewer",
        "mentalModel": "Chasser le SPOF"
      },
      {
        "name": "Rafael",
        "champion_slug": "rafael-reviewer",
        "role": "Findings Triager",
        "mentalModel": "Trier par sévérité"
      }
    ],
    "temporary": [
      {
        "name": "Sonia",
        "champion_slug": "sonia-security",
        "role": "Security Auditor",
        "mentalModel": "Adversarial sur les secrets",
        "note": "Ponctuel — audit sécurité (2 stories : surface + test)"
      }
    ],
    "stakeholders": [
      {
        "name": "Hélène (Life Connect)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  }
};

export const storiesByDoor = {
  "advisory": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Cadrer les sources de veille",
      "given": "aucun périmètre de veille défini",
      "when": "on liste concurrents, tendances et sources réglementaires à suivre",
      "then": "un cadre de sources daté est validé",
      "and": "chaque source est reproductible d'un cycle à l'autre",
      "status": "done",
      "priority": "high",
      "assignee": {
        "name": "Sasha",
        "champion_slug": "sasha-scout"
      },
      "phase": "steering"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Observer le marché clean beauty",
      "given": "le cadre de sources validé",
      "when": "on scanne les lancements concurrents et les signaux clean/minimaliste",
      "then": "les 2 sérums clean concurrents sont qualifiés et chiffrés",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Cléo",
        "champion_slug": "cleo-competitive"
      },
      "phase": "steering"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Produire le digest mensuel",
      "given": "les observations de veille du cycle",
      "when": "on consolide concurrents, tendances et réglementation",
      "then": "un digest daté et sourcé est publié",
      "and": "chaque item porte au moins 2 sources",
      "status": "in_review",
      "priority": "medium",
      "assignee": {
        "name": "Tariq",
        "champion_slug": "tariq-trends"
      },
      "phase": "steering"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Formuler la suggestion sérum clean Q3",
      "given": "le digest et la fenêtre Q3 identifiée",
      "when": "on formule une suggestion de ligne sérum clean à challenger",
      "then": "la suggestion devient une Idea/Goal documentée et sourcée",
      "and": "elle passe la revue réglementaire INCI/UE",
      "status": "planned",
      "priority": "high",
      "assignee": {
        "name": "Reza",
        "champion_slug": "reza-regulatory"
      },
      "phase": "steering"
    }
  ],
  "concern": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Diagnostiquer la vraie douleur du run mensuel",
      "given": "le process actuel 100% manuel (CSV + justificatifs)",
      "when": "on chronomètre un run réel et on décompose les étapes",
      "then": "on isole où partent les 2-3h (catégorisation vs recherche justificatif)",
      "and": "on chiffre le volume (~80 lignes) et le % de justificatifs introuvables",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Naïma",
        "champion_slug": "naima-ops"
      },
      "phase": "framing"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Cartographier le plan comptable et les sources de justificatifs",
      "given": "le référentiel comptable Horion et les boîtes mail providers (Heroku/Telenet/OVH)",
      "when": "on liste les catégories cibles et les formats de justificatifs par provider",
      "then": "on a une matrice catégorie ↔ source ↔ format exploitable",
      "status": "planned",
      "priority": "high",
      "assignee": {
        "name": "Bruno",
        "champion_slug": "bruno-compta"
      },
      "phase": "framing"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Poser les options et leur périmètre",
      "given": "le diagnostic chiffré et la matrice des sources",
      "when": "on formule 2-3 options (agent full, semi-auto assisté, statu quo outillé) avec coût/risque",
      "then": "chaque option a un périmètre explicite et une volumétrie associée",
      "and": "la surface d'accès aux données (emails, CSV) est revue par sécurité",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Léa",
        "champion_slug": "lea-architect"
      },
      "phase": "framing"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Trancher Goal-ou-Maintain",
      "given": "les options chiffrées et leur périmètre",
      "when": "le lead arbitre avec les stakeholders",
      "then": "une décision explicite est actée (engendrer un Goal de build OU une Maintain de run mensuel)",
      "status": "backlog",
      "priority": "urgent",
      "assignee": {
        "name": "Cédric",
        "champion_slug": "cadrik-framer"
      },
      "phase": "decision"
    }
  ],
  "decision": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Cadrer et pondérer les critères de décision",
      "given": "deux segments et deux options d'architecture",
      "when": "on définit les critères (coût, maintenance, UX, time-to-market, risque divergence)",
      "then": "chaque critère est pondéré et figé",
      "and": "validé par le Product Owner avant tout chiffrage",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Diane",
        "champion_slug": "diana-decider"
      },
      "phase": "framing"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Chiffrer les deux options (unifiée vs séparées)",
      "given": "les critères figés et l'audit des ~60% de features communes",
      "when": "on estime coût de build et coût de maintenance sur 18 mois pour chaque option",
      "then": "chaque option a un TCO chiffré et défendable",
      "and": "le chiffrage est revu par la FinOps Reviewer",
      "status": "planned",
      "priority": "high",
      "assignee": {
        "name": "Théo",
        "champion_slug": "theo-techlead"
      },
      "phase": "analysis"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Modéliser le risque de divergence à 18 mois",
      "given": "les roadmaps des deux segments",
      "when": "on modélise les scénarios de divergence des besoins et le coût de découplage tardif",
      "then": "le risque est quantifié et attaché à l'option unifiée",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Marc",
        "champion_slug": "marc-data"
      },
      "phase": "analysis"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Peser les options et recommander",
      "given": "les TCO chiffrés et le risque de divergence quantifié",
      "when": "on applique la grille pondérée aux deux options",
      "then": "la reco unifiée modulaire est argumentée ou réfutée par les chiffres",
      "and": "présentée au Sponsor avec les Goals engendrés",
      "status": "backlog",
      "priority": "urgent",
      "assignee": {
        "name": "Diane",
        "champion_slug": "diana-decider"
      },
      "phase": "recommendation"
    }
  ],
  "goal": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Poser le socle données (S2)",
      "given": "des données reporting hétérogènes en Excel",
      "when": "on définit et fige le schéma du socle",
      "then": "le modèle de données passe les migrations en CI",
      "and": "l'audit sécurité valide le chiffrement au repos",
      "status": "done",
      "priority": "high",
      "assignee": {
        "name": "Bruno",
        "champion_slug": "bruno-backend"
      },
      "phase": "build"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Générer le 1er rapport pilote",
      "given": "le socle données figé",
      "when": "on branche le moteur de rendu sur le stub custodian",
      "then": "un rapport complet est généré pour un mandat test",
      "and": "il est relu de bout en bout par le PO",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Sofia",
        "champion_slug": "sofia-fullstack"
      },
      "phase": "build"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Livrer le stub custodian iso-contrat (S3)",
      "given": "l'API custodian indisponible avant S3",
      "when": "on implémente un stub interne respectant le contrat réel",
      "then": "le swap vers l'API réelle se fait sans refactor",
      "and": "Karim valide qu'aucune donnée client ne fuite via le stub",
      "status": "planned",
      "priority": "urgent",
      "assignee": {
        "name": "Bruno",
        "champion_slug": "bruno-backend"
      },
      "phase": "build"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Onboarder les 3 pilotes et release (S8)",
      "given": "le 1er rapport validé et le stub en place",
      "when": "on onboarde les 3 clients pilotes",
      "then": "chacun génère son rapport et signe le go-live",
      "and": "le MVP est releasé en S8 dans le scope figé",
      "status": "backlog",
      "priority": "high",
      "assignee": {
        "name": "Inès",
        "champion_slug": "ines-onboarding"
      },
      "phase": "release"
    }
  ],
  "idea": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Publier la landing avec bouton « Réserver »",
      "given": "aucune page de réservation n'existe",
      "when": "on déploie une landing mono-page avec un bouton « Réserver »",
      "then": "la page est en ligne et le bouton ouvre le formulaire de signup",
      "and": "le formulaire respecte le consentement RGPD",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Lina",
        "champion_slug": "lina-landing"
      },
      "phase": "reasoning"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Instrumenter le tracking des clics « Réserver »",
      "given": "la landing est en ligne",
      "when": "une visiteuse clique « Réserver » et soumet le formulaire",
      "then": "le clic et le signup sont trackés et attribués à la source",
      "and": "les vues seules ne sont pas comptées comme signal",
      "status": "planned",
      "priority": "high",
      "assignee": {
        "name": "Marc",
        "champion_slug": "marc-data"
      },
      "phase": "reasoning"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Driver le trafic Instagram vers la landing",
      "given": "la landing trackée est en ligne",
      "when": "on redirige la bio et les DM Instagram vers l'URL",
      "then": "le trafic qualifié arrive sur la landing pendant 2 semaines",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Théo",
        "champion_slug": "theo-growth"
      },
      "phase": "reasoning"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Statuer le verdict kill / refine / proceed",
      "given": "les signups mesurés sur 2 semaines",
      "when": "on compare au seuil de 50 signups",
      "then": "on émet un verdict kill / refine / proceed",
      "and": "si proceed, on engendre un Goal de build",
      "status": "backlog",
      "priority": "urgent",
      "assignee": {
        "name": "Valentine",
        "champion_slug": "vera-validator"
      },
      "phase": "reasoning"
    }
  ],
  "improve": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Déployer la variante checkout 4 champs",
      "given": "le tunnel de production à 7 champs",
      "when": "on déploie la variante à 4 champs derrière un flag",
      "then": "elle est servie à 50 % du trafic checkout",
      "and": "le tracking GA4 distingue bien les deux bras",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Igor",
        "champion_slug": "igor-frontend"
      },
      "phase": "steering"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Lancer l'A/B et instrumenter la mesure",
      "given": "les deux bras servis à 50/50",
      "when": "on calcule la taille d'échantillon cible pour +0,8 pp à 95 %",
      "then": "le run A/B démarre avec une date de fin verrouillée",
      "and": "aucun peeking n'est autorisé avant cette date",
      "status": "planned",
      "priority": "high",
      "assignee": {
        "name": "Marc",
        "champion_slug": "marc-data"
      },
      "phase": "steering"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Statuer le levier à significativité",
      "given": "les résultats de l'A/B en fin de run",
      "when": "le seuil de significativité (95 %) est atteint",
      "then": "on garde le bras gagnant et on rollout à 100 %",
      "and": "on re-mesure et fige la nouvelle baseline sur 14 jours",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Olivia",
        "champion_slug": "olga-optimizer"
      },
      "phase": "steering"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Cadrer le levier suivant",
      "given": "la baseline re-mesurée après le checkout",
      "when": "on priorise le backlog de leviers (autofill adresse, express pay)",
      "then": "le levier #2 est cadré avec hypothèse de gain et plan de test",
      "status": "backlog",
      "priority": "low",
      "assignee": {
        "name": "Olivia",
        "champion_slug": "olga-optimizer"
      },
      "phase": "steering"
    }
  ],
  "maintain": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Triager les 7 tickets entrants par SLA",
      "given": "7 tickets ouverts dans la file",
      "when": "on les classe par priorité SLA",
      "then": "les P1 sont identifiés et assignés en premier",
      "and": "chaque P1 a une échéance à 4h",
      "status": "in_progress",
      "priority": "urgent",
      "assignee": {
        "name": "Iris",
        "champion_slug": "iris-triage"
      },
      "phase": "steering"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Fixer l'incident P1 sous SLA",
      "given": "un incident P1 ouvert en Issue dédiée",
      "when": "on déploie le patch de mitigation",
      "then": "le service est rétabli sous 4h",
      "and": "le runbook est mis à jour avec la cause",
      "status": "planned",
      "priority": "urgent",
      "assignee": {
        "name": "Théo",
        "champion_slug": "theo-oncall"
      },
      "phase": "steering"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Automatiser la purge des logs",
      "given": "la purge des logs faite manuellement chaque semaine",
      "when": "on déploie un job idempotent avec dry-run",
      "then": "la purge tourne en récurrent automatique",
      "and": "un rollback est documenté",
      "status": "backlog",
      "priority": "high",
      "assignee": {
        "name": "Nora",
        "champion_slug": "nora-automation"
      },
      "phase": "steering"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Renouveler les certs avant expiration",
      "given": "des certs proches de l'expiration",
      "when": "on lance le run récurrent de renouvellement",
      "then": "les certs sont renouvelés sans interruption",
      "and": "une alerte d'expiration est posée pour le prochain cycle",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Nora",
        "champion_slug": "nora-automation"
      },
      "phase": "steering"
    }
  ],
  "monitor": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Instrumenter la collecte du KPI rétention",
      "given": "les logs de facturation bruts",
      "when": "on branche le pipeline KPI quotidien",
      "then": "la rétention est calculée chaque jour depuis une source unique",
      "and": "la lecture initiale affiche 74 %",
      "status": "done",
      "priority": "high",
      "assignee": {
        "name": "Dina",
        "champion_slug": "dina-data"
      },
      "phase": "steering"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Créer l'alerte et le trigger sur seuil 70 %",
      "given": "le KPI rétention quotidien",
      "when": "la valeur franchit 70 % à la baisse",
      "then": "une notif est postée dans Slack #ops",
      "and": "un Goal/Issue est ouvert automatiquement",
      "status": "in_progress",
      "priority": "urgent",
      "assignee": {
        "name": "Oscar",
        "champion_slug": "oscar-ops"
      },
      "phase": "steering"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Lancer la boucle de surveillance quotidienne",
      "given": "le check et l'alerte déployés",
      "when": "le cron tourne chaque jour",
      "then": "le dashboard rétention se rafraîchit sans intervention",
      "and": "aucune action corrective n'est déclenchée par le monitor",
      "status": "planned",
      "priority": "medium",
      "assignee": {
        "name": "Sven",
        "champion_slug": "sven-supervisor"
      },
      "phase": "steering"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Tuner les triggers contre le flapping",
      "given": "des oscillations autour de 70 %",
      "when": "on ajoute une hysteresis de 2 points et l'idempotency",
      "then": "l'alerte ne se déclenche qu'une fois par franchissement réel",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Rita",
        "champion_slug": "rita-reliability"
      },
      "phase": "steering"
    }
  ],
  "prototype": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Cadrer l'hypothèse falsifiable",
      "given": "une intuition floue 'le scan miroir engage'",
      "when": "on écrit l'hypothèse en une phrase testable",
      "then": "le critère de succès de la démo est défini",
      "and": "l'appetite est fixé à 3 jours",
      "status": "done",
      "priority": "high",
      "assignee": {
        "name": "Pia",
        "champion_slug": "pia-product"
      },
      "phase": "framing"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Vibe-coder l'écran mocké",
      "given": "l'hypothèse cadrée et 0 backend",
      "when": "on code un seul écran avec données en dur",
      "then": "l'écran est cliquable et démo-able localement",
      "status": "in_progress",
      "priority": "urgent",
      "assignee": {
        "name": "Igor",
        "champion_slug": "igor-frontend"
      },
      "phase": "building"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Démo live à NC Cosmetic",
      "given": "l'écran cliquable",
      "when": "on le montre en live au PO et aux users",
      "then": "on capte le signal d'intérêt en direct",
      "status": "planned",
      "priority": "high",
      "assignee": {
        "name": "Léa",
        "champion_slug": "lea-researcher"
      },
      "phase": "building"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Trancher keep / throw / promote",
      "given": "le signal de la démo",
      "when": "on confronte le résultat à l'hypothèse",
      "then": "on décide go/no-go et on engendre un Goal ou une Automation",
      "and": "le code du spike est jeté ou réécrit, jamais promu tel quel",
      "status": "backlog",
      "priority": "urgent",
      "assignee": {
        "name": "Vince",
        "champion_slug": "vince-vibe"
      },
      "phase": "learn"
    }
  ],
  "question": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Inventorier les modules Odoo et le sur-mesure",
      "given": "l'instance Odoo en production chez Jardinac",
      "when": "on recense chaque module et marque ceux qui sont sur-mesure",
      "then": "on a la liste des sources de lock-in à re-développer",
      "and": "chaque module sur-mesure est estimé en effort de portage",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Théo",
        "champion_slug": "theo-erp"
      },
      "phase": "discovery"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Chiffrer le poste reprise de données",
      "given": "le volume et la complexité des données Odoo",
      "when": "on chiffre extraction, transformation et reprise vers chaque cible",
      "then": "le poste reprise est sourcé et représente ≈40% du TCO",
      "and": "l'estimation est traçable (devis ou modèle d'effort)",
      "status": "planned",
      "priority": "urgent",
      "assignee": {
        "name": "Sven",
        "champion_slug": "sven-data-migration"
      },
      "phase": "analysis"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Bâtir le modèle TCO 3 ans des alternatives",
      "given": "les postes chiffrés (licences, dev, reprise, formation)",
      "when": "on agrège ERPNext, sur-mesure et statu quo sur 3 ans",
      "then": "chaque alternative a un TCO sourcé et comparable",
      "and": "le statu quo apparaît avec un coût non nul",
      "status": "backlog",
      "priority": "high",
      "assignee": {
        "name": "Camille",
        "champion_slug": "camille-finops"
      },
      "phase": "analysis"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Synthétiser la recommandation chiffrée",
      "given": "le modèle TCO et l'analyse du lock-in",
      "when": "on rédige la synthèse pour le sponsor",
      "then": "Jardinac peut trancher entre migrer et rester, chiffres à l'appui",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Régis",
        "champion_slug": "regis-researcher"
      },
      "phase": "synthesis"
    }
  ],
  "review": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Cartographier la surface d'attaque",
      "given": "l'archi et les accès de Life Connect",
      "when": "on inventorie endpoints, secrets et stores",
      "then": "la surface d'attaque est documentée",
      "and": "les zones sensibles sont marquées",
      "status": "done",
      "priority": "high",
      "assignee": {
        "name": "Sonia",
        "champion_slug": "sonia-security"
      },
      "phase": "audit"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Tester sécurité + architecture",
      "given": "la surface cartographiée",
      "when": "on exécute les tests sécurité et la revue archi",
      "then": "chaque finding porte une preuve reproductible",
      "and": "l'absence de SPOF critique est vérifiée",
      "status": "in_review",
      "priority": "urgent",
      "assignee": {
        "name": "Aïcha",
        "champion_slug": "aicha-architect"
      },
      "phase": "audit"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Prioriser par sévérité + 1 Issue/bloquant",
      "given": "les findings avec preuves",
      "when": "on trie en 2 bloquants et 4 importants",
      "then": "une Issue est créée par bloquant",
      "and": "logs admin chiffrés et rotation clés API y sont tracés",
      "status": "in_progress",
      "priority": "urgent",
      "assignee": {
        "name": "Rafael",
        "champion_slug": "rafael-reviewer"
      },
      "phase": "audit"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Statuer go/no-go déploiement",
      "given": "les findings triés et les Issues bloquantes",
      "when": "on arbitre le verdict d'audit",
      "then": "le verdict est go conditionnel aux 2 fixes",
      "and": "il est signé avec preuves attachées",
      "status": "backlog",
      "priority": "high",
      "assignee": {
        "name": "Sven",
        "champion_slug": "sven-supervisor"
      },
      "phase": "verdict"
    }
  ]
};

export const memoryByMission = {
  "4fb3ce37-4ac9-459f-9cb9-cc0c44388af0": {
    "graphSpec": {
      "hub": "Maison Lumen — Cadrage",
      "entities": [
        "Entonnoir de vente",
        "Levier acquisition / conversion / panier / rétention",
        "Métrique cible",
        "Premier chantier"
      ],
      "insights": [
        "Outcome flou = leviers mesurables",
        "Frapper un seul levier d'abord",
        "Conversion = goulot probable"
      ],
      "sources": [
        "Analytics Shopify",
        "Entretien fondateur"
      ],
      "judgments": [
        "objectif-non-mesurable",
        "levier-choisi-sans-donnee"
      ],
      "regulations": [
        "Outcome chiffré obligatoire",
        "Un levier #1 unique"
      ],
      "backstory": [
        "Ventes plates",
        "Goal vague"
      ]
    },
    "backstory": "Maison Lumen veut « augmenter ses ventes » sans savoir où ça coince. La mission n'est pas d'exécuter mais de cadrer : décomposer l'objectif flou en leviers mesurables (acquisition, conversion, panier moyen, rétention) et choisir où frapper en premier avant d'engager le moindre chantier.",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucun chantier proposé sans outcome chiffré (métrique de départ + cible).",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Un seul levier #1 retenu pour le premier chantier — pas de front élargi.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Chaque levier prioritaire doit être adossé à une donnée de l'entonnoir, pas à une intuition.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "objectif-non-mesurable",
        "verdict": "BLOCK",
        "confidence": 0.91,
        "description": "Cadrer un chantier sur « augmenter les ventes » sans le traduire en métrique cible rend l'impact invérifiable.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "levier-choisi-sans-donnee",
        "verdict": "REJECT",
        "confidence": 0.84,
        "description": "Désigner le levier #1 sur une intuition au lieu d'un goulot mesuré dans l'entonnoir.",
        "status": "proposed"
      },
      {
        "id": "j3",
        "pattern": "front-elargi-multi-levier",
        "verdict": "PUSH BACK",
        "confidence": 0.78,
        "description": "Attaquer acquisition + conversion + rétention en même temps dilue l'effort et brouille l'attribution.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "La conversion est le goulot probable",
        "detail": "Trafic correct mais conversion sous 1,5 % — l'acquisition n'est pas le problème.",
        "confidence": 0.74,
        "source": "Analytics Shopify",
        "status": "review"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Outcome chiffré avant tout chantier",
        "detail": "Pas de passage en exécution sans baseline + cible explicite.",
        "confidence": 0.69,
        "source": "Door cadrage",
        "status": "proposed"
      },
      {
        "id": "p3",
        "kind": "backstory",
        "title": "Le fondateur confond ventes et trafic",
        "detail": "L'attente initiale était « plus de visiteurs » ; le cadrage doit recentrer sur la valeur convertie.",
        "confidence": 0.62,
        "source": "Entretien fondateur",
        "status": "proposed"
      }
    ]
  },
  "m-p1": {
    "graphSpec": {
      "hub": "Jardinac — Build",
      "entities": [
        "Onboarding J0-J14",
        "Séquence de relance",
        "Win-back",
        "Monitor churn"
      ],
      "insights": [
        "Churn = -20% / trimestre",
        "Pic d'attrition à J+30",
        "Relance avant renouvellement"
      ],
      "sources": [
        "Cohortes CRM",
        "Logs d'usage"
      ],
      "judgments": [
        "lever-sans-mesure",
        "relance-sans-segmentation"
      ],
      "regulations": [
        "Idempotency sur les envois",
        "Baseline churn figée"
      ],
      "backstory": [
        "Churn à 20%",
        "Renouvellements perdus"
      ]
    },
    "backstory": "Jardinac perd ~20% de ses clients par trimestre, l'attrition se concentrant juste avant la date de renouvellement. La mission build les leviers (onboarding, relance, win-back) et engendre un Monitor pour suivre le churn en continu.",
    "regulations": [
      {
        "id": "r1",
        "text": "Tout envoi de relance doit être idempotent — pas de double-contact sur un même client.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "La baseline churn est figée avant le premier levier et n'est re-mesurée qu'en fin de jalon.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Aucune relance envoyée sans segmentation par risque de churn.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "lever-sans-mesure",
        "verdict": "BLOCK",
        "confidence": 0.91,
        "description": "Déployer un levier sans instrumentation churn rend l'impact inattribuable.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "relance-sans-segmentation",
        "verdict": "REJECT",
        "confidence": 0.84,
        "description": "Relancer tous les clients à l'identique gaspille le budget et fatigue les comptes sains.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "win-back-sans-fenetre",
        "verdict": "PUSH BACK",
        "confidence": 0.72,
        "description": "Cibler le win-back sans fenêtre post-churn définie dilue les résultats.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "L'attrition culmine à J+30 après onboarding",
        "detail": "60% des churns surviennent dans le premier mois faute d'activation.",
        "confidence": 0.78,
        "source": "Cohortes CRM",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Relance déclenchée à J-15 du renouvellement",
        "detail": "Fenêtre fixe avant échéance pour standardiser les tests.",
        "confidence": 0.63,
        "source": "Séquence de relance",
        "status": "proposed"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "REVERT",
        "title": "Pas de win-back sur les clients churned pour non-paiement",
        "detail": "Segment à faible LTV récupéré — ROI négatif observé.",
        "confidence": 0.55,
        "source": "Logs d'usage",
        "status": "review"
      }
    ]
  },
  "m-p2": {
    "graphSpec": {
      "hub": "NC Cosmetic — Build",
      "entities": [
        "Pricing v2 — 3 paliers",
        "Migration clients",
        "Grandfathering",
        "Page pricing"
      ],
      "insights": [
        "Migrer sans churn",
        "Grandfather = anti-churn",
        "Go-live derrière flag"
      ],
      "sources": [
        "Cohortes facturation",
        "Benchmarks pricing SaaS"
      ],
      "judgments": [
        "migration-sans-grandfathering",
        "go-live-sans-rollback"
      ],
      "regulations": [
        "Pas de hausse forcée",
        "Migration idempotente"
      ],
      "backstory": [
        "Pricing v1 illisible",
        "Marge érodée"
      ]
    },
    "backstory": "NC Cosmetic vend sur un pricing v1 à un seul plan devenu illisible et sous-margé. La mission lance le pricing v2 à 3 paliers et fait migrer la base existante sans churn, en grandfatherant les clients actuels.",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucun client existant ne subit de hausse de prix forcée sans grandfathering explicite.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "La logique de migration doit être idempotente : rejouer le batch ne double jamais une facturation.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Go-live uniquement derrière un feature flag avec rollback documenté.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "migration-sans-grandfathering",
        "verdict": "BLOCK",
        "confidence": 0.92,
        "description": "Migrer la base sans grandfather les clients v1 déclenche du churn évitable.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "go-live-sans-rollback",
        "verdict": "REJECT",
        "confidence": 0.88,
        "description": "Passer le pricing v2 en prod sans flag ni plan de rollback documenté.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "comm-clients-apres-bascule",
        "verdict": "PUSH BACK",
        "confidence": 0.74,
        "description": "Communiquer le changement de prix aux clients après la bascule au lieu d'avant.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "Grandfathering = principal levier anti-churn",
        "detail": "Cohorte v1 figée 12 mois : projection de churn < 2 % vs ~9 % en hausse forcée.",
        "confidence": 0.81,
        "source": "Cohortes facturation",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Dry-run obligatoire de la migration sur un clone",
        "detail": "Rejouer le batch sur un snapshot avant prod, vérifier les montants palier par palier.",
        "confidence": 0.69,
        "source": "Postmortem v1",
        "status": "review"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "REVERT",
        "title": "Pas de 4e palier ajouté en cours de build",
        "detail": "Toute extension du modèle au-delà des 3 paliers signés est un scope-creep à reverter.",
        "confidence": 0.6,
        "source": "Brief signé",
        "status": "proposed"
      }
    ]
  },
  "m-v1": {
    "graphSpec": {
      "hub": "Helios Pay — Build",
      "entities": [
        "Schéma v3",
        "Dual-write",
        "Backfill 42M lignes",
        "Plan de rollback"
      ],
      "insights": [
        "Zéro downtime obligatoire",
        "Dual-write avant bascule",
        "Vérif intégrité = gate"
      ],
      "sources": [
        "Schéma prod v2",
        "Runbook SRE"
      ],
      "judgments": [
        "bascule-sans-rollback",
        "backfill-non-idempotent"
      ],
      "regulations": [
        "Rollback testé avant prod",
        "Dual-write avant lecture v3"
      ],
      "backstory": [
        "v2 sature",
        "Perte de données interdite"
      ]
    },
    "backstory": "Le schéma v2 de Helios Pay sature (jointures lentes, types trop étroits sur les montants) et bloque la roadmap paiements. La mission migre vers v3 sans downtime : tout écart d'intégrité ou rollback non testé est un risque de perte de données, donc inacceptable.",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucune bascule en lecture v3 sans rollback testé en staging.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Le dual-write doit être actif et vérifié avant tout backfill.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Chaque script de migration doit être idempotent et rejouable.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "bascule-sans-rollback",
        "verdict": "BLOCK",
        "confidence": 0.94,
        "description": "Basculer la lecture sur v3 sans rollback documenté et testé expose à une perte de données irréversible.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "backfill-non-idempotent",
        "verdict": "REJECT",
        "confidence": 0.88,
        "description": "Un backfill non rejouable laisse des lignes orphelines si le job échoue en cours.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "dual-write-silencieux-en-echec",
        "verdict": "PUSH BACK",
        "confidence": 0.72,
        "description": "Une écriture v3 qui échoue sans alerter laisse diverger les deux schémas.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "regulation",
        "title": "Comparer un échantillon v2/v3 après chaque batch de backfill",
        "detail": "Checksum sur 1 % des lignes par batch pour détecter une divergence tôt.",
        "confidence": 0.74,
        "source": "Runbook SRE",
        "status": "review"
      },
      {
        "id": "p2",
        "kind": "judgment",
        "verdict": "REJECT",
        "title": "Bascule lecture sans canary",
        "detail": "Passer 100 % du trafic lecture en une fois plutôt qu'un canary 5 %.",
        "confidence": 0.68,
        "source": "Postmortem migration v1→v2",
        "status": "proposed"
      },
      {
        "id": "p3",
        "kind": "insight",
        "title": "Le backfill domine la fenêtre de risque",
        "detail": "42M lignes en batchs de 10k : ~70 min, fenêtre la plus longue de divergence possible.",
        "confidence": 0.81,
        "source": "Schéma prod v2",
        "status": "accepted"
      }
    ]
  },
  "m-v2": {
    "graphSpec": {
      "hub": "NC Cosmetic — Build",
      "entities": [
        "Endpoint webhook",
        "Idempotency store",
        "Retry backoff",
        "Réconciliation"
      ],
      "insights": [
        "0 paiement perdu",
        "Signature avant tout",
        "Pas de refacto checkout"
      ],
      "sources": [
        "Docs Stripe",
        "Logs paiements"
      ],
      "judgments": [
        "webhook-sans-verif-signature",
        "retry-sans-idempotency"
      ],
      "regulations": [
        "Signature vérifiée obligatoire",
        "Endpoint idempotent"
      ],
      "backstory": [
        "Paiements perdus",
        "Webhooks non fiables"
      ]
    },
    "backstory": "NC Cosmetic perd des paiements quand un webhook Stripe arrive en double ou échoue silencieusement. La mission fiabilise l'ingestion webhook (signature, idempotency, retry, réconciliation) sans toucher au checkout existant — objectif 0 paiement perdu.",
    "regulations": [
      {
        "id": "r1",
        "text": "Tout webhook entrant doit passer la vérification de signature Stripe avant traitement.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "L'endpoint webhook doit être idempotent : un même event_id ne produit qu'un seul effet.",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Le checkout existant ne doit pas être refactoré dans cette mission.",
        "severity": "hard"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "webhook-sans-verif-signature",
        "verdict": "BLOCK",
        "confidence": 0.94,
        "description": "Traiter un payload webhook sans vérifier la signature ouvre la porte au spoofing de paiements.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "retry-sans-idempotency",
        "verdict": "REJECT",
        "confidence": 0.88,
        "description": "Rejouer un webhook sans clé d'idempotence double-crédite la commande.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "refacto-checkout-hors-scope",
        "verdict": "REVERT",
        "confidence": 0.8,
        "description": "Modifier le tunnel checkout sort des boundaries de la mission (no-go).",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "L'idempotency store est le point critique",
        "detail": "C'est lui qui garantit 0 double-crédit malgré les retries Stripe.",
        "confidence": 0.85,
        "source": "Docs Stripe + logs paiements",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Retry avec backoff exponentiel plafonné",
        "detail": "Backoff exponentiel, max 5 tentatives, puis dead-letter pour réconciliation.",
        "confidence": 0.7,
        "source": "Build retry/backoff",
        "status": "review"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "PUSH BACK",
        "title": "Réconciliation quotidienne non négociable",
        "detail": "Sans job de réconciliation, les events ratés restent invisibles.",
        "confidence": 0.62,
        "source": "Revue sécurité ponctuelle",
        "status": "proposed"
      }
    ]
  },
  "m-v3": {
    "graphSpec": {
      "hub": "OrbitFlow — Build",
      "entities": [
        "Pipeline d'événements",
        "Agrégation serveur",
        "Transport SSE/WS",
        "Widgets configurables"
      ],
      "insights": [
        "Latence = transport",
        "Pré-agréger en fenêtres",
        "Budget < 2s p95"
      ],
      "sources": [
        "Bench latence",
        "Specs produit"
      ],
      "judgments": [
        "mesurer-la-latence-end-to-end",
        "pas-de-calcul-cote-client"
      ],
      "regulations": [
        "p95 < 2s gate",
        "Idempotency sur events"
      ],
      "backstory": [
        "Dashboards en batch",
        "Décision trop tardive"
      ]
    },
    "backstory": "OrbitFlow pilote ses opérations sur des dashboards rafraîchis en batch toutes les 15 min, ce qui rend les décisions tardives. La mission construit un pipeline temps réel de bout en bout (events → agrégation → transport → widgets) avec un SLA de latence p95 < 2s.",
    "regulations": [
      {
        "id": "r1",
        "text": "Aucune story livrée si la latence p95 end-to-end dépasse 2s sous charge nominale.",
        "severity": "hard"
      },
      {
        "id": "r2",
        "text": "Tout event entrant doit être idempotent (clé de déduplication obligatoire).",
        "severity": "hard"
      },
      {
        "id": "r3",
        "text": "Le client ne calcule pas d'agrégat : il consomme des fenêtres pré-agrégées côté serveur.",
        "severity": "soft"
      }
    ],
    "judgments": [
      {
        "id": "j1",
        "pattern": "agregation-cote-client",
        "verdict": "BLOCK",
        "confidence": 0.91,
        "description": "Calculer les agrégats dans le widget casse le budget latence et duplique la logique métier.",
        "status": "confirmed"
      },
      {
        "id": "j2",
        "pattern": "transport-sans-backpressure",
        "verdict": "REJECT",
        "confidence": 0.84,
        "description": "Un canal WS/SSE sans backpressure noie le client sous les bursts d'events.",
        "status": "confirmed"
      },
      {
        "id": "j3",
        "pattern": "perf-validee-a-vide",
        "verdict": "PUSH BACK",
        "confidence": 0.78,
        "description": "Valider le SLA latence sans charge réaliste donne un faux vert.",
        "status": "proposed"
      }
    ],
    "proposals": [
      {
        "id": "p1",
        "kind": "insight",
        "title": "Le transport est le poste de latence dominant",
        "detail": "Le fan-out WS pèse ~60% du budget p95 ; pré-agréger en fenêtres de 1s libère la marge.",
        "confidence": 0.74,
        "source": "Bench latence",
        "status": "accepted"
      },
      {
        "id": "p2",
        "kind": "regulation",
        "title": "Charge nominale obligatoire pour valider le SLA",
        "detail": "Rejouer 10k events/s avant de déclarer une story perf done.",
        "confidence": 0.68,
        "source": "Cycle build",
        "status": "review"
      },
      {
        "id": "p3",
        "kind": "judgment",
        "verdict": "REVERT",
        "title": "Pas de widget couplé à un format d'event interne",
        "detail": "Un widget qui lit le schéma brut des events casse à chaque évolution du pipeline.",
        "confidence": 0.61,
        "source": "Revue UI",
        "status": "proposed"
      }
    ]
  }
};

export const squadByMission = {
  "4fb3ce37-4ac9-459f-9cb9-cc0c44388af0": {
    "lead": {
      "name": "Cécile",
      "champion_slug": "cecile-cadreur",
      "role": "Cadreur / AM",
      "mentalModel": "Un flou cadré vaut dix chantiers lancés"
    },
    "permanent": [
      {
        "name": "Marc",
        "champion_slug": "marc-data",
        "role": "Data Analyst",
        "mentalModel": "Le goulot se mesure, pas se devine"
      },
      {
        "name": "Sofia",
        "champion_slug": "sofia-strateg",
        "role": "Growth Strategist",
        "mentalModel": "Un levier, un pari, une cible"
      }
    ],
    "temporary": [
      {
        "name": "Théo",
        "champion_slug": "theo-finance",
        "role": "Finance Reviewer",
        "mentalModel": "La cible doit tenir au P&L",
        "note": "Ponctuel — sanity-check de la métrique cible (1 story)"
      }
    ],
    "stakeholders": [
      {
        "name": "Hélène (Maison Lumen)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "m-p1": {
    "lead": {
      "name": "Robin",
      "champion_slug": "robin-retention",
      "role": "Retention Lead",
      "mentalModel": "Mesurer le churn avant de le combattre"
    },
    "permanent": [
      {
        "name": "Léa",
        "champion_slug": "lea-lifecycle",
        "role": "Lifecycle Marketer",
        "mentalModel": "Segmenter avant de relancer"
      },
      {
        "name": "Sam",
        "champion_slug": "sam-backend",
        "role": "Backend Engineer",
        "mentalModel": "Webhooks idempotents, SLA tenu"
      },
      {
        "name": "Nora",
        "champion_slug": "nora-data",
        "role": "Data Analyst",
        "mentalModel": "Baseline figée, impact prouvé"
      }
    ],
    "temporary": [
      {
        "name": "Théo",
        "champion_slug": "theo-deliverability",
        "role": "Deliverability Specialist",
        "mentalModel": "Réputation d'envoi avant volume",
        "note": "Ponctuel — audit délivrabilité des relances (2 stories)"
      }
    ],
    "stakeholders": [
      {
        "name": "Camille (Jardinac)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "m-p2": {
    "lead": {
      "name": "Bruno",
      "champion_slug": "bruno-builder",
      "role": "Delivery Lead",
      "mentalModel": "Migrer sans casser, livrer derrière un flag"
    },
    "permanent": [
      {
        "name": "Sofia",
        "champion_slug": "sofia-pricing",
        "role": "Pricing Engineer",
        "mentalModel": "Modéliser les paliers, garantir l'idempotency"
      },
      {
        "name": "Igor",
        "champion_slug": "igor-frontend",
        "role": "Frontend Engineer",
        "mentalModel": "Page pricing claire, conversion en tête"
      },
      {
        "name": "Léa",
        "champion_slug": "lea-lifecycle",
        "role": "Lifecycle Marketer",
        "mentalModel": "Communiquer avant la bascule, pas après"
      }
    ],
    "temporary": [
      {
        "name": "Karim",
        "champion_slug": "karim-billing-audit",
        "role": "Billing Reviewer",
        "mentalModel": "Adversarial sur la facturation",
        "note": "Ponctuel — audit migration/grandfathering (2 stories)"
      }
    ],
    "stakeholders": [
      {
        "name": "Nadia (NC Cosmetic)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "m-v1": {
    "lead": {
      "name": "Magnus",
      "champion_slug": "magnus-migrator",
      "role": "Migration Lead",
      "mentalModel": "Pas de bascule sans rollback testé"
    },
    "permanent": [
      {
        "name": "Dimitri",
        "champion_slug": "dimitri-data",
        "role": "Data Engineer",
        "mentalModel": "Backfill idempotent, rejouable"
      },
      {
        "name": "Bjorn",
        "champion_slug": "bjorn-backend",
        "role": "Backend Engineer",
        "mentalModel": "Dual-write observé en continu"
      }
    ],
    "temporary": [
      {
        "name": "Solveig",
        "champion_slug": "solveig-sre",
        "role": "SRE Reviewer",
        "mentalModel": "Adversarial sur le rollback",
        "note": "Ponctuel — revue rollback + bascule (2 stories)"
      }
    ],
    "stakeholders": [
      {
        "name": "Lena (Helios Pay)",
        "role": "Tech Lead",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "m-v2": {
    "lead": {
      "name": "Boris",
      "champion_slug": "boris-backend-lead",
      "role": "Backend Lead",
      "mentalModel": "0 paiement perdu, idempotent par défaut"
    },
    "permanent": [
      {
        "name": "Nadia",
        "champion_slug": "nadia-backend",
        "role": "Backend Engineer",
        "mentalModel": "Signature d'abord, payload ensuite"
      },
      {
        "name": "Théo",
        "champion_slug": "theo-backend",
        "role": "Backend Engineer",
        "mentalModel": "Retry plafonné, jamais à l'infini"
      }
    ],
    "temporary": [
      {
        "name": "Sofia",
        "champion_slug": "sofia-security-reviewer",
        "role": "Security Reviewer",
        "mentalModel": "Adversarial sur la surface webhook",
        "note": "Ponctuel — audit sécurité signature + idempotency (2 stories)"
      }
    ],
    "stakeholders": [
      {
        "name": "Nadia (NC Cosmetic)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  },
  "m-v3": {
    "lead": {
      "name": "Rafa",
      "champion_slug": "rafa-realtime",
      "role": "Realtime Lead",
      "mentalModel": "Le budget latence dicte l'archi"
    },
    "permanent": [
      {
        "name": "Bilal",
        "champion_slug": "bilal-backend",
        "role": "Backend Engineer",
        "mentalModel": "Agréger côté serveur, pas côté client"
      },
      {
        "name": "Sora",
        "champion_slug": "sora-streaming",
        "role": "Streaming Engineer",
        "mentalModel": "Backpressure sur chaque canal"
      },
      {
        "name": "Lena",
        "champion_slug": "lena-frontend",
        "role": "Frontend Engineer",
        "mentalModel": "Widgets configurables, zéro calcul client"
      }
    ],
    "temporary": [
      {
        "name": "Otto",
        "champion_slug": "otto-perf",
        "role": "Perf Reviewer",
        "mentalModel": "Mesurer sous charge réelle",
        "note": "Ponctuel — audit latence sous charge (2 stories)"
      }
    ],
    "stakeholders": [
      {
        "name": "Maya (OrbitFlow)",
        "role": "Product Owner",
        "human_role": "stakeholder"
      },
      {
        "name": "Greg",
        "role": "Sponsor",
        "human_role": "board-member"
      }
    ]
  }
};

export const storiesByMission = {
  "4fb3ce37-4ac9-459f-9cb9-cc0c44388af0": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Cartographier l'entonnoir de vente",
      "given": "des données analytics éparses",
      "when": "on reconstruit le tunnel visiteur → achat",
      "then": "chaque étape porte un taux mesuré",
      "and": "les fuites sont visibles",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Marc",
        "champion_slug": "marc-data"
      },
      "phase": "cadrage"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Identifier le levier #1",
      "given": "l'entonnoir cartographié",
      "when": "on compare acquisition / conversion / panier / rétention",
      "then": "un seul levier prioritaire est désigné",
      "and": "il est adossé au plus gros goulot mesuré",
      "status": "planned",
      "priority": "urgent",
      "assignee": {
        "name": "Sofia",
        "champion_slug": "sofia-strateg"
      },
      "phase": "cadrage"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Définir la métrique cible",
      "given": "le levier #1 retenu",
      "when": "on fixe baseline et objectif chiffré",
      "then": "la cible est mesurable et datée",
      "and": "elle tient au P&L",
      "status": "backlog",
      "priority": "high",
      "assignee": {
        "name": "Cécile",
        "champion_slug": "cecile-cadreur"
      },
      "phase": "cadrage"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Proposer un premier chantier",
      "given": "levier et cible cadrés",
      "when": "on scope le chantier d'exécution minimal",
      "then": "un Brief actionnable est présenté",
      "and": "il est signé off par le PO",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Cécile",
        "champion_slug": "cecile-cadreur"
      },
      "phase": "cadrage"
    }
  ],
  "m-p1": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Refondre l'onboarding J0-J14",
      "given": "un onboarding plat où 60% churnent à J+30",
      "when": "on déploie un parcours d'activation guidé sur 14 jours",
      "then": "le taux d'activation à J+14 est tracké par cohorte",
      "and": "l'événement d'activation alimente le Monitor churn",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Léa",
        "champion_slug": "lea-lifecycle"
      },
      "phase": "shaping"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Construire la séquence de relance pré-renouvellement",
      "given": "les comptes segmentés par risque de churn",
      "when": "on déclenche la séquence à J-15 du renouvellement",
      "then": "chaque envoi est idempotent et loggé",
      "and": "seuls les comptes à risque élevé sont contactés",
      "status": "planned",
      "priority": "high",
      "assignee": {
        "name": "Sam",
        "champion_slug": "sam-backend"
      },
      "phase": "shaping"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Lancer la campagne win-back",
      "given": "les clients churned dans une fenêtre de 30 à 90 jours",
      "when": "on envoie une offre de réactivation ciblée",
      "then": "les non-paiements sont exclus du segment",
      "and": "le taux de réactivation est mesuré par segment",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Léa",
        "champion_slug": "lea-lifecycle"
      },
      "phase": "shaping"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Mesurer l'impact churn vs baseline",
      "given": "la baseline churn figée et les trois leviers déployés",
      "when": "le jalon se clôt",
      "then": "le Monitor compare le churn au -20% visé",
      "and": "l'impact est attribué levier par levier",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Nora",
        "champion_slug": "nora-data"
      },
      "phase": "shaping"
    }
  ],
  "m-p2": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Modéliser les 3 paliers de pricing v2",
      "given": "le pricing v1 à plan unique",
      "when": "on définit les 3 paliers avec quotas et prix",
      "then": "le modèle est versionné et testé",
      "and": "chaque palier a son SKU de facturation",
      "status": "in_review",
      "priority": "high",
      "assignee": {
        "name": "Sofia",
        "champion_slug": "sofia-pricing"
      },
      "phase": "shaping"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Construire la page pricing v2",
      "given": "le modèle à 3 paliers validé",
      "when": "on livre la page pricing publique",
      "then": "les 3 paliers s'affichent avec CTA",
      "and": "elle est servie derrière un feature flag",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Igor",
        "champion_slug": "igor-frontend"
      },
      "phase": "shaping"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Logique de migration + grandfathering",
      "given": "la base de clients v1",
      "when": "on exécute le batch de migration",
      "then": "les clients existants sont grandfatherés sans hausse",
      "and": "le batch est idempotent et validé en dry-run",
      "status": "planned",
      "priority": "urgent",
      "assignee": {
        "name": "Sofia",
        "champion_slug": "sofia-pricing"
      },
      "phase": "shaping"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Communication clients + go-live",
      "given": "la migration validée en dry-run",
      "when": "on envoie la comm puis on lève le flag",
      "then": "les clients sont prévenus avant la bascule",
      "and": "le rollback reste disponible 48 h",
      "status": "backlog",
      "priority": "medium",
      "assignee": {
        "name": "Léa",
        "champion_slug": "lea-lifecycle"
      },
      "phase": "shaping"
    }
  ],
  "m-v1": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Écrire le script de migration de schéma v3",
      "given": "le schéma v2 en prod",
      "when": "on applique le script de création v3",
      "then": "les tables v3 existent en parallèle de v2",
      "and": "le script est idempotent et rejouable",
      "status": "done",
      "priority": "high",
      "assignee": {
        "name": "Dimitri",
        "champion_slug": "dimitri-data"
      },
      "phase": "building"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Activer le dual-write v2/v3",
      "given": "les tables v3 créées",
      "when": "une écriture applicative arrive",
      "then": "elle est persistée dans v2 et v3",
      "and": "tout échec d'écriture v3 lève une alerte",
      "status": "in_progress",
      "priority": "urgent",
      "assignee": {
        "name": "Bjorn",
        "champion_slug": "bjorn-backend"
      },
      "phase": "building"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Backfill des 42M lignes historiques vers v3",
      "given": "le dual-write actif et vérifié",
      "when": "on rejoue le backfill par batchs de 10k",
      "then": "toutes les lignes v2 sont présentes en v3",
      "and": "un checksum d'échantillon confirme l'intégrité par batch",
      "status": "planned",
      "priority": "high",
      "assignee": {
        "name": "Dimitri",
        "champion_slug": "dimitri-data"
      },
      "phase": "building"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Basculer la lecture sur v3 avec rollback testé",
      "given": "le backfill terminé et l'intégrité vérifiée",
      "when": "on bascule un canary 5 % de la lecture sur v3",
      "then": "les lectures sont servies par v3 sans écart",
      "and": "le rollback vers v2 est documenté et rejoué en staging",
      "status": "backlog",
      "priority": "urgent",
      "assignee": {
        "name": "Magnus",
        "champion_slug": "magnus-migrator"
      },
      "phase": "building"
    }
  ],
  "m-v2": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Endpoint webhook + vérification de signature",
      "given": "un endpoint webhook Stripe exposé",
      "when": "un event arrive avec un header Stripe-Signature",
      "then": "la signature est vérifiée avant tout traitement",
      "and": "un payload non signé renvoie 400 sans effet",
      "status": "in_progress",
      "priority": "urgent",
      "assignee": {
        "name": "Nadia",
        "champion_slug": "nadia-backend"
      },
      "phase": "building"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Idempotency store sur event_id",
      "given": "un event déjà traité",
      "when": "le même event_id revient",
      "then": "aucun second effet n'est produit",
      "and": "la réponse reste 200 pour Stripe",
      "status": "in_progress",
      "priority": "urgent",
      "assignee": {
        "name": "Boris",
        "champion_slug": "boris-backend-lead"
      },
      "phase": "building"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Retry avec backoff exponentiel",
      "given": "un traitement webhook en échec transitoire",
      "when": "le système replanifie la tentative",
      "then": "le backoff est exponentiel et plafonné à 5 essais",
      "and": "l'échec final part en dead-letter",
      "status": "planned",
      "priority": "high",
      "assignee": {
        "name": "Théo",
        "champion_slug": "theo-backend"
      },
      "phase": "building"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Job de réconciliation + tests",
      "given": "le dead-letter et l'API Stripe",
      "when": "le job de réconciliation tourne",
      "then": "tout event manquant est rejoué de façon idempotente",
      "and": "les tests prouvent 0 paiement perdu",
      "status": "backlog",
      "priority": "high",
      "assignee": {
        "name": "Sofia",
        "champion_slug": "sofia-security-reviewer"
      },
      "phase": "building"
    }
  ],
  "m-v3": [
    {
      "id": "s1",
      "seq": 1,
      "title": "Pipeline d'ingestion d'events idempotent",
      "given": "des events bruts en flux continu",
      "when": "ils entrent dans le pipeline",
      "then": "chaque event est dédupliqué via sa clé d'idempotency",
      "and": "les doublons sont rejetés sans casser l'ordre",
      "status": "done",
      "priority": "high",
      "assignee": {
        "name": "Bilal",
        "champion_slug": "bilal-backend"
      },
      "phase": "building"
    },
    {
      "id": "s2",
      "seq": 2,
      "title": "Agrégation serveur en fenêtres glissantes",
      "given": "le flux d'events dédupliqués",
      "when": "on les agrège en fenêtres de 1s côté serveur",
      "then": "le client reçoit des agrégats prêts à afficher",
      "and": "aucun calcul d'agrégat ne reste côté client",
      "status": "in_progress",
      "priority": "urgent",
      "assignee": {
        "name": "Bilal",
        "champion_slug": "bilal-backend"
      },
      "phase": "building"
    },
    {
      "id": "s3",
      "seq": 3,
      "title": "Transport temps réel WS/SSE avec backpressure",
      "given": "des fenêtres agrégées prêtes",
      "when": "on les pousse via WebSocket avec fallback SSE",
      "then": "le canal applique du backpressure sous burst",
      "and": "aucun event n'est perdu en pic de charge",
      "status": "in_progress",
      "priority": "high",
      "assignee": {
        "name": "Sora",
        "champion_slug": "sora-streaming"
      },
      "phase": "building"
    },
    {
      "id": "s4",
      "seq": 4,
      "title": "Widgets configurables + perf p95 < 2s sous charge",
      "given": "le flux agrégé livré au front",
      "when": "on rejoue 10k events/s sur des widgets configurables",
      "then": "la latence end-to-end p95 reste < 2s",
      "and": "le layout des widgets est persisté par utilisateur",
      "status": "planned",
      "priority": "urgent",
      "assignee": {
        "name": "Lena",
        "champion_slug": "lena-frontend"
      },
      "phase": "building"
    }
  ]
};
